import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBirthday({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 2.25c.41 0 .75.34.75.75v3.25H13c.94 0 1.67.8 1.74 1.76l.01.16V14h.75c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5H.5A.5.5 0 010 15v-.5c0-.28.22-.5.5-.5h.75V8.17c0-1.04.76-1.92 1.75-1.92h4.25V3c0-.38.28-.7.65-.74zm2 7.9c-.12 0-.2.07-.46.46l-.1.15c-.44.63-.78.89-1.44.89-.71 0-1.05-.3-1.54-1.04l-.14-.2c-.16-.21-.23-.26-.32-.26-.1 0-.17.05-.33.27l-.24.35c-.44.62-.78.88-1.44.88-.56 0-.89-.19-1.24-.63V14h10.5v-2.99c-.36.45-.69.64-1.25.64-.71 0-1.05-.3-1.54-1.04l-.07-.1c-.2-.3-.28-.36-.39-.36zm3-2.4H3c-.11 0-.25.16-.25.42v.86c.28.16.51.44.8.86l.13.21c.15.2.22.25.31.25.12 0 .2-.07.47-.46l.1-.15C5 9.1 5.34 8.85 6 8.85c.7 0 1.05.3 1.54 1.04l.07.1c.2.3.28.36.39.36.12 0 .2-.07.46-.46l.1-.15c.44-.63.78-.89 1.44-.89.71 0 1.05.3 1.54 1.04l.07.1c.2.3.28.36.39.36.12 0 .2-.07.46-.46l.1-.15c.24-.34.45-.57.7-.71l-.01-.86c0-.26-.14-.42-.25-.42zM8 0a.75.75 0 110 1.5A.75.75 0 018 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicBirthday.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBirthday.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicBirthday svgRef={ref} {...props} />);
export default ForwardRef;
